/* Akko Society · tema Shopify
   Interacciones del sitio. Los datos salen de Shopify:
   · #akkoSalidas: productos de la colección de salidas (metacampos custom.*)
   · #akkoMapa: textos y puntos del mapa (sección "Mapa de salidas")
   · window.TOPO: relieve y curvas de nivel reales (SRTM, assets/akko-topo.js)
   Todo lo demás se lee de atributos data-* que escribe Liquid. */
(function () {
  "use strict";
  var A = window.AKKO || {}, TT = A.t || {};
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); };
  var lerp = function (a, b, t) { return a + (b - a) * t; };
  var pad = function (n) { return String(n).padStart(2, "0"); };
  var LOC = A.locale === "en" ? "en-US" : "es-CO";
  var num = function (n) { return Number(n || 0).toLocaleString(LOC); };
  var starSvg = function (style) { return '<svg class="star" viewBox="1100 10 480 595" aria-hidden="true"' + (style ? ' style="' + style + '"' : "") + '><use href="#p-star"/></svg>'; };
  function json(id, fb) { var el = document.getElementById(id); if (!el) return fb; try { return JSON.parse(el.textContent); } catch (e) { return fb; } }
  function onView(el, cb, th) {
    if (!el) return;
    if (!("IntersectionObserver" in window)) return cb();
    new IntersectionObserver(function (es, ob) { if (es[0].isIntersecting) { ob.disconnect(); cb(); } }, { threshold: th || .2 }).observe(el);
  }
  /* ---------- Fechas (epoch en segundos desde Liquid) ---------- */
  function fmtDate(ts, kind) {
    var d = new Date(ts * 1000);
    if (kind === "short") return pad(d.getDate()) + "." + pad(d.getMonth() + 1);
    if (kind === "mon") return d.toLocaleDateString(LOC, { month: "short" }).replace(/\./g, "").toUpperCase();
    if (kind === "day") return d.toLocaleDateString(LOC, { day: "numeric", month: "long" });
    if (kind === "chip") return d.toLocaleDateString(LOC, { weekday: "short", day: "numeric", month: "short" }).replace(/\./g, "");
    return d.toLocaleDateString(LOC, { weekday: "short", day: "numeric", month: "short", year: "numeric" }).replace(/\./g, "");
  }
  // Rango de varios días: "sáb 28 – dom 29 nov 2026" (o "sáb 28 nov – lun 1 dic 2026" si cambia el mes)
  function fmtRange(ts, te, kind) {
    var a = new Date(ts * 1000), b = new Date(te * 1000), same = a.getMonth() === b.getMonth();
    function part(d, withMonth, withYear) {
      var o = { weekday: "short", day: "numeric" }; if (withMonth) o.month = "short"; if (withYear) o.year = "numeric";
      return d.toLocaleDateString(LOC, o).replace(/\./g, "").replace(",", "");
    }
    var year = kind !== "chip" && kind !== "short";
    if (kind === "short") return pad(a.getDate()) + "–" + pad(b.getDate()) + "." + pad(b.getMonth() + 1);
    return part(a, !same, false) + " – " + part(b, true, year);
  }
  $$("[data-num]").forEach(function (el) { var v = +el.textContent; if (!isNaN(v)) el.textContent = num(v); });
  $$("[data-date]").forEach(function (el) { var ts = +el.dataset.date, te = +el.dataset.end; if (ts) el.textContent = te && el.dataset.fmt !== "mon" ? fmtRange(ts, te, el.dataset.fmt) : fmtDate(ts, el.dataset.fmt); });
  // Si la página llegó en caché después de la fecha, la salida pasada deja el inicio y aparece el bloque de "nuevas fechas".
  $$("[data-expires]").forEach(function (el) {
    if (+el.dataset.expires * 1000 > Date.now()) return;
    var empty = el.parentNode.querySelector("[data-ticket-empty]");
    if (empty) { el.hidden = true; empty.hidden = false; }
  });
  function untilParts(ts) { var ms = Math.max(0, ts * 1000 - Date.now()); return { d: Math.floor(ms / 864e5), h: Math.floor(ms / 36e5) % 24, m: Math.floor(ms / 6e4) % 60, s: Math.floor(ms / 1e3) % 60 }; }

  /* ---------- Datos ---------- */
  var SAL = json("akkoSalidas", []);
  var MAPA = json("akkoMapa", null);
  var T = window.TOPO || null;
  if (T && A.relieve) Object.keys(A.relieve).forEach(function (k) { if (T[k]) T[k].img = A.relieve[k]; });
  var nowS = Date.now() / 1000;
  var upcoming = SAL.filter(function (t) { return t.ts && t.ts > nowS; }).sort(function (a, b) { return a.ts - b.ts; });
  var NEXT = upcoming.filter(function (t) { return !t.secret; })[0] || null;
  var BASE = A.base || { lat: 6.2442, lon: -75.5812 };

  /* =========================================================
     TOPOGRAFÍA REAL (SRTM)
     ========================================================= */
  function regPaths(r, minorCls, majorCls, step) {
    var mi = "", ma = "";
    Object.keys(r.cont).forEach(function (lv) { if (+lv % (step || 500) === 0) ma += r.cont[lv]; else mi += r.cont[lv]; });
    return '<path class="' + minorCls + '" d="' + mi + '"/><path class="' + majorCls + '" d="' + ma + '"/>';
  }
  function mercY(lat) { return Math.log(Math.tan(Math.PI / 4 + lat * Math.PI / 360)); }
  function frameXY(r, lat, lon) { var b = r.bbox; return [(lon - b[2]) / (b[3] - b[2]) * r.W, (mercY(b[1]) - mercY(lat)) / (mercY(b[1]) - mercY(b[0])) * r.H]; }
  function dms(v, pos, neg) { var a = Math.abs(v), d = Math.floor(a), m = Math.round((a - d) * 60); if (m === 60) { d++; m = 0; } return d + "°" + pad(m) + "′" + (v >= 0 ? pos : neg); }
  var GRIDS = {};
  function gridOf(k) {
    if (GRIDS[k]) return GRIDS[k];
    var g = T[k].grid, bin = atob(g.b), arr = new Uint16Array(g.w * g.h);
    for (var i = 0; i < arr.length; i++) arr[i] = bin.charCodeAt(2 * i) | (bin.charCodeAt(2 * i + 1) << 8);
    return (GRIDS[k] = { w: g.w, h: g.h, a: arr });
  }
  function elevAt(lat, lon) {
    if (!T) return null;
    var keys = ["oriente", "nuqui", "ruiz"];
    for (var i = 0; i < keys.length; i++) {
      var r = T[keys[i]], b = r.bbox;
      if (lat < b[0] || lat > b[1] || lon < b[2] || lon > b[3]) continue;
      var g = gridOf(keys[i]), fx = (lon - b[2]) / (b[3] - b[2]) * (g.w - 1), fy = (mercY(b[1]) - mercY(lat)) / (mercY(b[1]) - mercY(b[0])) * (g.h - 1);
      var x0 = Math.floor(fx), y0 = Math.floor(fy), x1 = Math.min(g.w - 1, x0 + 1), y1 = Math.min(g.h - 1, y0 + 1), rx = fx - x0, ry = fy - y0;
      return Math.round(lerp(lerp(g.a[y0 * g.w + x0], g.a[y0 * g.w + x1], rx), lerp(g.a[y1 * g.w + x0], g.a[y1 * g.w + x1], rx), ry));
    }
    return null;
  }
  var TOPO_NAMES = { oriente: "VALLE DE ABURRÁ Y ORIENTE ANTIOQUEÑO", ruiz: "PARQUE NACIONAL LOS NEVADOS", nuqui: "NUQUÍ, CHOCÓ" };
  function initTopos() {
    if (!T) return;
    $$(".topo-bg[data-topo]").forEach(function (el) {
      var k = el.dataset.topo; if (!T[k]) k = "oriente";
      var r = T[k];
      el.classList.add("topo-real");
      el.style.setProperty("--tc", el.dataset.color || "rgba(27,28,28,.14)");
      el.innerHTML = '<svg viewBox="0 0 ' + r.W + " " + r.H + '" preserveAspectRatio="xMidYMid slice">' + regPaths(r, "mi", "ma") + '</svg><span class="topo-cap data">' + esc(TT.realContours || "CURVAS REALES") + " · " + TOPO_NAMES[k] + "</span>";
      onView(el, function () { el.classList.add("in"); }, .05);
    });
  }

  /* =========================================================
     CUENTAS REGRESIVAS
     ========================================================= */
  var U = TT.units || ["días", "horas", "min", "seg"];
  function tickCountdowns() {
    var cd = $("#countdown");
    if (cd && NEXT) {
      var p = untilParts(NEXT.ts), cap = (cd.dataset.cap || "").replace("[salida]", NEXT.nombre);
      cd.innerHTML = '<span class="cap">' + esc(cap) + "</span>" + [["d", U[0]], ["h", U[1]], ["m", U[2]], ["s", U[3]]].map(function (u) { return '<div><div class="n">' + pad(p[u[0]]) + '</div><div class="u">' + esc(u[1]) + "</div></div>"; }).join("");
    } else if (cd) cd.hidden = true;
    $$("[data-countdown]").forEach(function (el) {
      var q = untilParts(+el.dataset.countdown);
      if (el.dataset.style === "big") el.innerHTML = [["d", U[0]], ["h", U[1]], ["m", U[2]], ["s", U[3]]].map(function (u) { return "<div><b>" + pad(q[u[0]]) + "</b><span>" + esc(u[1]) + "</span></div>"; }).join("");
      else if (el.dataset.style === "ticket") el.innerHTML = "<b>" + q.d + "</b><span>D</span><b>" + pad(q.h) + "</b><span>H</span><b>" + pad(q.m) + "</b><span>MIN</span>";
      else el.textContent = q.d + " d " + pad(q.h) + " h " + pad(q.m) + " min";
    });
  }

  /* =========================================================
     MAPA: Colombia → zonas, sobre relieve real
     ========================================================= */
  var mapState = { vb: null, key: "co", anim: 0 }, selected = null, PLACES = [];
  var CO = T && T.co;
  function worldXY(lat, lon) { return frameXY(CO, lat, lon); }
  function worldToLL(x, y) {
    var b = CO.bbox, lon = b[2] + x / CO.W * (b[3] - b[2]);
    var my = mercY(b[1]) - y / CO.H * (mercY(b[1]) - mercY(b[0]));
    return [(2 * Math.atan(Math.exp(my)) - Math.PI / 2) * 180 / Math.PI, lon];
  }
  function regRect(r) { var a = worldXY(r.bbox[1], r.bbox[2]), c = worldXY(r.bbox[0], r.bbox[3]); return { x: a[0], y: a[1], w: c[0] - a[0], h: c[1] - a[1] }; }
  function fitRect(r, a, cover) { var w = r.w, h = r.h; if ((w / h > a) === !!cover) w = h * a; else h = w / a; return { x: r.x + r.w / 2 - w / 2, y: r.y + r.h / 2 - h / 2, w: w, h: h }; }
  function mapTarget(key) {
    var m = $("#map"), a = m.clientWidth / Math.max(1, m.clientHeight);
    if (key === "co") return fitRect({ x: -30, y: -20, w: CO.W + 60, h: CO.H + 40 }, a, false);
    var r = regRect(T[key]);
    if (key === "oriente") {
      // Si una salida queda fuera del recorte de relieve (p. ej. La Peña, al sur), se amplía la vista para que su punto se vea.
      var x0 = r.x, y0 = r.y, x1 = r.x + r.w, y1 = r.y + r.h, pad = r.w * .06;
      TRAILS.forEach(function (t) { var q = worldXY(t.lat, t.lon); x0 = Math.min(x0, q[0] - pad); x1 = Math.max(x1, q[0] + pad); y0 = Math.min(y0, q[1] - pad); y1 = Math.max(y1, q[1] + pad * 4); });
      r = { x: x0, y: y0, w: x1 - x0, h: y1 - y0 };
    }
    return fitRect(r, a, false);
  }
  function mapPx(lat, lon) { var vb = mapState.vb, m = $("#map"), w = worldXY(lat, lon); return [(w[0] - vb.x) / vb.w * m.clientWidth, (w[1] - vb.y) / vb.h * m.clientHeight]; }
  var TRAILS = SAL.filter(function (t) { return t.lat && t.lon && (!t.ts || t.ts > nowS); });
  function mapUpdate() {
    var vb = mapState.vb, map = $("#map"), cw = map.clientWidth, ch = map.clientHeight;
    $("#mapSvg").setAttribute("viewBox", vb.x.toFixed(3) + " " + vb.y.toFixed(3) + " " + vb.w.toFixed(3) + " " + vb.h.toFixed(3));
    var near = vb.w < 230, op = Math.max(0, Math.min(1, (480 - vb.w) / 300));
    $$(".map-reg", map).forEach(function (s) { s.style.opacity = op.toFixed(3); });
    map.classList.toggle("near", near);
    $$("#mapPins [data-ll]").forEach(function (p) {
      var ll = p.dataset.ll.split(","), q = mapPx(+ll[0], +ll[1]), z = p.dataset.z;
      var vis = (z === "all" || (z === "near") === near) && q[0] > -30 && q[1] > -30 && q[0] < cw + 30 && q[1] < ch - 44;
      p.style.transform = "translate(" + q[0].toFixed(1) + "px," + q[1].toFixed(1) + "px) translate(-50%,-50%)";
      p.classList.toggle("off", !vis); p.tabIndex = vis ? 0 : -1;
      var tg = p.querySelector(".tag"); if (tg && vis) { var hw = tg.offsetWidth / 2, dx = Math.max(8 + hw - q[0], Math.min(0, cw - 8 - hw - q[0])); tg.style.translate = dx ? dx.toFixed(1) + "px 0" : ""; }
    });
    var b = mapPx(BASE.lat, BASE.lon), d = "";
    var targets = near ? TRAILS.map(function (t) { return [t.id, t.lat, t.lon]; }) : (MAPA.showExpe ? [["nuqui", 5.7106, -77.2706], ["ruiz", 4.85, -75.34]] : []);
    targets.forEach(function (t) {
      var p = mapPx(t[1], t[2]), mx = (b[0] + p[0]) / 2 + (p[1] - b[1]) * .22, my = (b[1] + p[1]) / 2 - (p[0] - b[0]) * .22;
      d += '<path data-line="' + esc(t[0]) + '" class="' + (t[0] === selected ? "on" : "") + '" d="M' + b[0].toFixed(1) + " " + b[1].toFixed(1) + " Q" + mx.toFixed(1) + " " + my.toFixed(1) + " " + p[0].toFixed(1) + " " + p[1].toFixed(1) + '"/>';
    });
    var ml = $("#mapLines"); ml.setAttribute("viewBox", "0 0 " + cw + " " + ch); ml.innerHTML = d;
    var ll = worldToLL(vb.x + vb.w / 2, vb.y + vb.h / 2), kmPx = vb.w / cw * (CO.bbox[3] - CO.bbox[2]) / CO.W * 111.32 * Math.cos(ll[0] * Math.PI / 180);
    var nice = [1, 2, 5, 10, 20, 50, 100, 200, 500].find(function (n) { return n / kmPx >= 56; }) || 500;
    $("#mapScaleBar").style.width = (nice / kmPx).toFixed(0) + "px"; $("#mapScale").textContent = nice + " KM";
  }
  function mapGo(key, instant) {
    var to = mapTarget(key);
    mapState.key = key;
    $$("[data-mapv]").forEach(function (b) { b.setAttribute("aria-pressed", String(b.dataset.mapv === key)); });
    cancelAnimationFrame(mapState.anim);
    if (instant || reduce || !mapState.vb) { mapState.vb = to; mapUpdate(); return; }
    var from = mapState.vb, t0 = performance.now(), a = to.w / to.h;
    var c0 = [from.x + from.w / 2, from.y + from.h / 2], c1 = [to.x + to.w / 2, to.y + to.h / 2];
    var dist = Math.hypot(c1[0] - c0[0], c1[1] - c0[1]), bump = Math.max(0, dist / Math.max(from.w, to.w) - .6);
    var D = 1300 + Math.min(900, bump * 500);
    (function step(now) {
      var p = Math.min(1, (now - t0) / D), e = p < .5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
      var w = Math.exp(lerp(Math.log(from.w), Math.log(to.w), e)) * (1 + bump * Math.sin(Math.PI * e)), h = w / a;
      var cx = lerp(c0[0], c1[0], e), cy = lerp(c0[1], c1[1], e);
      mapState.vb = { x: cx - w / 2, y: cy - h / 2, w: w, h: h }; mapUpdate();
      if (p < 1) mapState.anim = requestAnimationFrame(step);
    })(t0);
  }
  function scramble(str) { return esc(str).replace(/\d/g, function () { return "<i>" + "?#*"[Math.floor(Math.random() * 3)] + "</i>"; }); }
  function markPins(id) {
    $$("#mapPins .pin").forEach(function (p) { p.setAttribute("aria-pressed", String((p.dataset.pin || p.dataset.place) === id)); });
    $$("[data-line]").forEach(function (l) { l.classList.toggle("on", l.dataset.line === id); });
  }
  function cupos(t) { if (!t.cupos) return ""; if (t.quedan < 0) return '<div class="cupos static"><span class="t-label">' + esc((MAPA.t.group || "").replace("[n]", t.cupos)) + "</span></div>"; return '<div class="cupos" style="--used:' + (1 - t.quedan / t.cupos).toFixed(2) + '"><span class="t-label">' + (t.quedan > 0 ? esc(MAPA.t.left.replace("[n]", t.quedan).replace("[total]", t.cupos)) : esc(MAPA.t.soldOut)) + '</span><span class="cupos-bar"><i></i></span></div>'; }
  function panelExpe(key) {
    var x = MAPA.expe[key], r = T[key]; if (!x) return;
    markPins("z-" + key); selected = key;
    $("#mapPanel").innerHTML = '<div class="photo"><img src="' + esc(x.img) + '" alt=""></div><div class="panel-body"><div style="display:flex;gap:6px;flex-wrap:wrap"><span class="chip dark">' + esc(MAPA.t.expedition) + '</span><span class="chip warn">' + esc(x.status) + "</span></div>" +
      '<span class="data muted">' + esc(x.place.toUpperCase()) + "</span><h3>" + esc(x.title) + "</h3>" +
      '<dl class="panel-stats"><div><dt>' + esc(MAPA.t.altitude) + "</dt><dd>" + num(Math.max(0, r.min)) + "–" + num(r.max) + " m</dd></div><div><dt>" + esc(MAPA.t.terrain) + "</dt><dd>" + esc(x.terrain) + "</dd></div><div><dt>" + esc(MAPA.t.coords) + "</dt><dd>" + esc(x.coords) + "</dd></div></dl>" +
      '<p class="muted" style="font-size:14px">' + esc(MAPA.t.fewSpots) + '</p><a class="btn btn-dark" href="' + esc(x.url) + '"><span>' + esc(MAPA.t.seeExpe) + '</span><svg class="btn-star" aria-hidden="true"><use href="#star"/></svg></a></div>';
  }
  function panelCafe() {
    var c = MAPA.cafe; markPins("fredonia"); selected = "fredonia";
    var stats = (c.stats || "").split(/\n/).filter(Boolean).map(function (l) { var i = l.indexOf(":"); return i < 0 ? "" : "<div><dt>" + esc(l.slice(0, i).trim()) + "</dt><dd>" + esc(l.slice(i + 1).trim()) + "</dd></div>"; }).join("");
    $("#mapPanel").innerHTML = '<div class="photo"><img src="' + esc(c.img) + '" alt=""></div><div class="panel-body"><div style="display:flex;gap:6px"><span class="chip dark">' + esc(c.chip) + "</span></div>" +
      '<span class="data muted">' + esc(c.place) + "</span><h3>" + esc(c.title) + '</h3><dl class="panel-stats">' + stats + "</dl>" +
      '<p class="muted" style="font-size:14px">' + esc(c.text) + '</p><a class="btn btn-dark" href="' + esc(c.url) + '"><span>' + esc(c.cta) + '</span><svg class="btn-star" aria-hidden="true"><use href="#star"/></svg></a></div>';
  }
  function selectTrail(id) {
    var t = SAL.find(function (x) { return x.id === id; }), panel = $("#mapPanel");
    if (!t) {
      if (id === "fredonia") return panelCafe();
      if (MAPA.showExpe && MAPA.expe[id]) return panelExpe(id);
      panel.innerHTML = '<div class="panel-body"><p class="muted">' + esc(MAPA.t.empty) + "</p></div>";
      return;
    }
    selected = id; markPins(id);
    if (t.secret) {
      var code = dms(t.lat, "N", "S") + " " + dms(t.lon, "E", "O");
      panel.innerHTML = '<div class="photo blur"><img src="' + esc(t.img) + '" alt=""></div><div class="panel-body"><span class="chip warn" style="justify-self:start">' + esc(MAPA.t.secretTag) + "</span><h3>" + esc(MAPA.t.secretTitle) + "</h3>" +
        '<p class="muted">' + esc(MAPA.t.secretText) + '</p><p class="secret-code" id="secretCode">' + scramble(code) + "</p>" +
        '<dl class="panel-stats"><div><dt>' + esc(MAPA.t.distance) + "</dt><dd>?? km</dd></div><div><dt>" + esc(MAPA.t.gain) + "</dt><dd>+??? m</dd></div><div><dt>" + esc(TT.spots || "Cupos") + "</dt><dd>" + t.cupos + "</dd></div></dl>" +
        (t.reveal ? '<p class="data muted">' + esc(MAPA.t.reveals) + ' <span data-countdown="' + t.reveal + '" style="color:var(--orange)"></span></p>' : "") +
        '<a class="btn btn-dark" href="' + esc(t.url) + '"><span>' + esc(MAPA.t.notify) + "</span></a></div>";
      tickCountdowns();
      if (!reduce) { var sc = $("#secretCode"), n = 0, iv = setInterval(function () { if (!sc.isConnected || ++n > 30) return clearInterval(iv); sc.innerHTML = scramble(code); }, 120); }
      return;
    }
    var el = elevAt(t.lat, t.lon);
    panel.innerHTML = '<div class="photo"><img src="' + esc(t.img) + '" alt="' + esc(t.nombre) + '"></div><div class="panel-body">' +
      '<div style="display:flex;gap:6px;flex-wrap:wrap">' + (t.ts ? '<span class="chip dark">' + esc(fmtDate(t.ts, "chip")) + "</span>" : "") + (t.quedan > 0 && t.quedan <= 8 ? '<span class="chip warn">' + esc((TT.left || "Quedan [n]").replace("[n]", t.quedan)) + "</span>" : "") + "</div>" +
      '<span class="data muted">' + esc(t.lugar.toUpperCase()) + (el ? " · " + num(el) + " MSNM" : "") + "</span><h3>" + esc(t.nombre) + "</h3>" +
      '<dl class="panel-stats"><div><dt>' + esc(MAPA.t.distance) + "</dt><dd>" + t.km + " km</dd></div><div><dt>" + esc(MAPA.t.gain) + "</dt><dd>+" + num(t.desnivel) + " m</dd></div><div><dt>" + esc(MAPA.t.difficulty) + "</dt><dd>" + t.dif + "/5</dd></div></dl>" +
      '<div class="prod-row"><span class="price">' + esc(t.precio) + "</span>" + cupos(t) + "</div>" +
      '<a class="btn btn-dark" href="' + esc(t.url) + '"><span>' + esc(MAPA.t.book) + '</span><svg class="btn-star" aria-hidden="true"><use href="#star"/></svg></a></div>';
  }
  function initMap() {
    var map = $("#map"); if (!map || !T || !MAPA) return;
    PLACES = [{ id: "base", kind: "base", lat: BASE.lat, lon: BASE.lon, tag: MAPA.base, z: "all" }];
    if (MAPA.cafe.show) PLACES.push({ id: "fredonia", kind: "cafe", lat: MAPA.cafe.lat, lon: MAPA.cafe.lon, tag: MAPA.cafe.tag, z: "all" });
    PLACES.push({ id: "z-oriente", kind: "zone", side: "r", go: "oriente", lat: 6.1, lon: -75.3, tag: MAPA.zonaSalidas, z: "far" });
    if (MAPA.showExpe) PLACES.push(
      { id: "z-nuqui", kind: "zone", go: "nuqui", expe: "nuqui", lat: 5.7106, lon: -77.2706, tag: MAPA.expe.nuqui.tag, z: "far", side: "l" },
      { id: "z-ruiz", kind: "zone", go: "ruiz", expe: "ruiz", lat: 4.85, lon: -75.34, tag: MAPA.expe.ruiz.tag, z: "far", side: "r" },
      { id: "nuqui-town", kind: "town", expe: "nuqui", lat: 5.7106, lon: -77.2706, tag: "NUQUÍ", z: "near" },
      { id: "ruiz-peak", kind: "peak", expe: "ruiz", lat: 4.892, lon: -75.324, tag: "NEVADO DEL RUIZ", z: "near" },
      { id: "isabel-peak", kind: "peak", expe: "ruiz", lat: 4.818, lon: -75.365, tag: "NEVADO SANTA ISABEL", z: "near" });
    var regs = (MAPA.showExpe ? ["oriente", "nuqui", "ruiz"] : ["oriente"]).map(function (k) {
      var r = T[k], q = regRect(r);
      return '<svg class="map-reg" data-reg="' + k + '" x="' + q.x.toFixed(3) + '" y="' + q.y.toFixed(3) + '" width="' + q.w.toFixed(3) + '" height="' + q.h.toFixed(3) + '" viewBox="0 0 ' + r.W + " " + r.H + '" preserveAspectRatio="none"><image href="' + r.img + '" width="' + r.W + '" height="' + r.H + '"/>' + regPaths(r, "c-mi", "c-ma") + "</svg>";
    }).join("");
    var pins = PLACES.map(function (p) {
      var inner = p.kind === "base" ? '<span class="dot">' + starSvg("width:100%;height:100%") + "</span>" : p.kind === "peak" ? '<span class="dot tri"></span>' : '<span class="dot"></span>';
      return '<button class="pin ' + p.kind + (p.side ? " side-" + p.side : "") + '" type="button" data-place="' + p.id + '" data-ll="' + p.lat + "," + p.lon + '" data-z="' + p.z + '">' + inner + '<span class="tag">' + esc(p.tag) + "</span></button>";
    }).join("") + TRAILS.map(function (t) {
      return '<button class="pin' + (t.secret ? " secret" : "") + '" type="button" data-pin="' + esc(t.id) + '" data-ll="' + t.lat + "," + t.lon + '" data-z="near" aria-pressed="false"><span class="dot"></span><span class="tag">' + (t.secret ? "??.?? · " + esc(MAPA.t.secretTitle.toUpperCase()) : (t.ts ? fmtDate(t.ts, "short") + " · " : "") + esc(t.nombre.toUpperCase())) + "</span></button>";
    }).join("");
    map.innerHTML = '<svg class="map-svg" id="mapSvg" preserveAspectRatio="none" aria-hidden="true"><rect x="-2000" y="-2000" width="5000" height="5000" class="sea"/><image href="' + CO.img + '" width="' + CO.W + '" height="' + CO.H + '"/>' + regPaths(CO, "c-mi", "c-ma", 1000) + '<path class="co-line" d="' + CO.outline + '"/>' + regs + "</svg>" +
      '<svg class="map-lines" id="mapLines" aria-hidden="true"></svg><div id="mapPins">' + pins + '</div><div class="map-read data" id="mapRead" aria-hidden="true"></div>' +
      '<div class="map-tabs" role="group">' + MAPA.tabs.map(function (v) { return '<button type="button" data-mapv="' + v[0] + '" aria-pressed="false">' + esc(v[1]) + "</button>"; }).join("") + "</div>" +
      '<svg class="compass" viewBox="0 0 40 40" aria-hidden="true"><circle cx="20" cy="20" r="18"/><path d="M20 5 L24 20 L20 35 L16 20 Z"/><text x="20" y="4" text-anchor="middle">N</text></svg>' +
      '<div class="map-legend data"><span>' + esc(MAPA.legend) + '</span><span class="map-scale"><i id="mapScaleBar"></i><b id="mapScale"></b></span></div>';
    map.addEventListener("click", function (e) {
      var v = e.target.closest("[data-mapv]"); if (v) { mapGo(v.dataset.mapv); return; }
      var p = e.target.closest("[data-pin]"); if (p) { selectTrail(p.dataset.pin); return; }
      var pl = e.target.closest("[data-place]"); if (!pl) return;
      var P = PLACES.find(function (x) { return x.id === pl.dataset.place; });
      if (P.go) mapGo(P.go);
      if (P.expe && MAPA.showExpe) panelExpe(P.expe);
      if (P.kind === "cafe" && MAPA.cafe.url) location.href = MAPA.cafe.url;
    });
    var read = $("#mapRead");
    map.addEventListener("pointermove", function (e) {
      if (e.pointerType !== "mouse" || e.target.closest(".pin, .map-tabs")) { read.classList.remove("on"); return; }
      var r = map.getBoundingClientRect(), x = e.clientX - r.left, y = e.clientY - r.top, vb = mapState.vb;
      var ll = worldToLL(vb.x + x / r.width * vb.w, vb.y + y / r.height * vb.h), el = elevAt(ll[0], ll[1]);
      read.textContent = dms(ll[0], "N", "S") + " " + dms(ll[1], "E", "O") + (el !== null ? " · " + num(el) + " M" : "");
      read.style.transform = "translate(" + Math.min(x + 16, r.width - 190) + "px," + (y + 18) + "px)"; read.classList.add("on");
    });
    map.addEventListener("pointerleave", function () { read.classList.remove("on"); });
    mapGo("co", true);
    onView(map, function () { setTimeout(function () { mapGo("oriente"); }, reduce ? 0 : 450); }, .35);
    var rz; window.addEventListener("resize", function () { clearTimeout(rz); rz = setTimeout(function () { mapGo(mapState.key, true); }, 120); });
    var first = upcoming.filter(function (t) { return t.lat && t.lon; })[0];
    selectTrail(first ? first.id : "");
  }

  /* =========================================================
     CAFÉ: el método dripbag animado (línea de tiempo de 15 s)
     ========================================================= */
  var BREW_AT = [0, 3.2, 8.4, 12.6], BREW_T = 15;
  function kf(t, keys) {
    if (t <= keys[0][0]) return keys[0][1];
    for (var i = 1; i < keys.length; i++) if (t <= keys[i][0]) { var a = keys[i - 1], b = keys[i], p = (t - a[0]) / (b[0] - a[0]); p = p < .5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2; return lerp(a[1], b[1], p); }
    return keys[keys.length - 1][1];
  }
  var brew = { t: 0, playing: false, last: 0, visible: false, raf: 0 }, brewBtns = [];
  function brewFrame(t, now) {
    var $b = function (id) { return document.getElementById(id); };
    var by = kf(t, [[0, 40], [.6, 62], [2.2, 62], [3.2, 196], [12.6, 196], [13.6, 30]]);
    var bx = kf(t, [[12.6, 150], [13.6, 250]]);
    var br = kf(t, [[0, -8], [2.2, -5], [3.2, 0], [12.6, 0], [13.6, 26]]);
    var bo = Math.min(kf(t, [[0, 0], [.6, 1]]), kf(t, [[12.9, 1], [13.6, 0]]));
    var bag = $b("bagG"); bag.setAttribute("transform", "translate(" + bx.toFixed(1) + " " + by.toFixed(1) + ") rotate(" + br.toFixed(2) + ")"); bag.style.opacity = bo.toFixed(2);
    var tx = kf(t, [[.6, 0], [1.4, 70]]), ty = kf(t, [[.6, 0], [1.4, -40]]), tr = kf(t, [[.6, 0], [1.4, 50]]);
    var tear = $b("tear"); tear.setAttribute("transform", "translate(" + tx.toFixed(1) + " " + ty.toFixed(1) + ") rotate(" + tr.toFixed(1) + " 48 -6)"); tear.style.opacity = kf(t, [[1, 1], [1.4, 0]]).toFixed(2);
    var arm = kf(t, [[1.4, .04], [2.2, 1]]);
    $b("armL").setAttribute("transform", "translate(-48 0) scale(" + arm.toFixed(3) + " 1) translate(48 0)");
    $b("armR").setAttribute("transform", "translate(48 0) scale(" + arm.toFixed(3) + " 1) translate(-48 0)");
    var wl = kf(t, [[3.9, 114], [5, 40], [5.6, 58], [6.6, 30], [7.2, 50], [8.2, 24], [12.4, 100], [12.6, 114]]);
    $b("bagWater").setAttribute("y", wl.toFixed(1));
    var kx = kf(t, [[3.2, 110], [3.8, 0], [8.4, 0], [9, 120]]), ko = Math.min(kf(t, [[3.2, 0], [3.7, 1]]), kf(t, [[8.5, 1], [9, 0]]));
    var pours = [[3.9, 5.0], [5.6, 6.6], [7.2, 8.2]], pour = pours.find(function (p) { return t >= p[0] && t <= p[1]; });
    var ka = kf(t, [[3.8, 4], [3.95, -22], [5, -22], [5.15, -6], [5.55, -6], [5.7, -22], [6.6, -22], [6.75, -6], [7.15, -6], [7.3, -22], [8.2, -22], [8.4, 4]]);
    var k = $b("kettle"); k.setAttribute("transform", "translate(" + (158 + kx).toFixed(1) + " 150) rotate(" + ka.toFixed(1) + ")"); k.style.opacity = ko.toFixed(2);
    var st = $b("stream"); st.style.opacity = pour ? "1" : "0"; st.style.strokeDashoffset = pour ? Math.max(0, 1 - (t - pour[0]) * 6).toFixed(3) : "1";
    var lvl = kf(t, [[4.4, 344], [12.4, 258], [13.4, 254]]);
    var ph = (now || 0) / 520, d = "M40 " + lvl.toFixed(1);
    for (var x = 40; x <= 262; x += 14) d += " L" + x + " " + (lvl + Math.sin(ph + x / 18) * (lvl < 340 ? 1.6 : 0)).toFixed(1);
    $b("coffee").setAttribute("d", d + " L262 380 L40 380 Z");
    $b("crema").setAttribute("cy", (lvl + 1).toFixed(1)); $b("crema").style.opacity = kf(t, [[12.8, 0], [13.8, .9]]).toFixed(2);
    var dripOn = t > 4.4 && t < 12.7;
    $$("#brewDrops circle").forEach(function (c, i) {
      var f = ((now || 0) / 700 + i / 3) % 1, y0 = by + 112, y = lerp(y0, lvl, f * f);
      c.setAttribute("cx", 150); c.setAttribute("cy", y.toFixed(1)); c.style.opacity = dripOn && y < lvl - 2 ? "1" : "0";
    });
    $b("dripbag").classList.toggle("done", t >= 13.4);
    var secs = Math.round(kf(t, [[4.4, 0], [12.4, 180]]));
    $b("brewTimer").textContent = pad(Math.floor(secs / 60)) + ":" + pad(secs % 60);
    var si = t < .01 ? -1 : BREW_AT.reduce(function (a, b, i) { return t >= b ? i : a; }, 0);
    brewBtns.forEach(function (b, i) { b.setAttribute("aria-selected", String(i === si)); });
    var bt = $b("brewText"), txt = si < 0 ? bt.dataset.intro : t >= 13.4 ? bt.dataset.done : (brewBtns[si] ? brewBtns[si].dataset.text : "");
    if (bt.textContent !== txt) bt.textContent = txt;
    $b("brewBar").style.transform = "scaleX(" + (t / BREW_T).toFixed(4) + ")";
    $b("brewReplay").hidden = t < BREW_T;
  }
  function brewLoop(now) {
    if (brew.playing) { brew.t = Math.min(BREW_T, brew.t + (now - brew.last) / 1000); if (brew.t >= BREW_T) brew.playing = false; }
    brew.last = now; brewFrame(brew.t, now);
    brew.raf = brew.visible ? requestAnimationFrame(brewLoop) : 0;
  }
  function brewPlay(from) {
    brew.t = from; brew.playing = !reduce;
    if (reduce) { var nx = BREW_AT.find(function (b) { return b > from + .01; }); brew.t = nx ? nx - .01 : BREW_T; brewFrame(brew.t, 0); return; }
    if (!brew.raf) { brew.last = performance.now(); brew.raf = requestAnimationFrame(brewLoop); }
  }
  function initCafe() {
    var board = $("#beanBoard"), steps = $("#brewSteps");
    if (board && steps && $("#bagG")) {
      brewBtns = $$("[data-brew]", steps);
      steps.addEventListener("click", function (e) { var b = e.target.closest("[data-brew]"); if (b) brewPlay(BREW_AT[+b.dataset.brew]); });
      $("#brewReplay").addEventListener("click", function () { brewPlay(0); });
      brewFrame(reduce ? BREW_T : 0, 0);
      var started = false;
      if ("IntersectionObserver" in window) new IntersectionObserver(function (es) {
        brew.visible = es[0].isIntersecting;
        if (brew.visible && !started) { started = true; brewPlay(reduce ? BREW_T : 0); }
        else if (brew.visible && !brew.raf && !reduce) { brew.last = performance.now(); brew.raf = requestAnimationFrame(brewLoop); }
      }, { threshold: .35 }).observe(board);
      else { brew.visible = true; brewPlay(0); }
    }
    // Paquetes de dripbag: cambian la cantidad del formulario y el total.
    $$("[data-pack-form]").forEach(function (f) {
      var qty = $("[data-pack-qty]", f), btn = $("[data-unit]", f), sum = $("[data-sum]", f);
      f.addEventListener("click", function (e) {
        var b = e.target.closest("[data-pack]"); if (!b) return;
        $$("[data-pack]", f).forEach(function (x) { x.setAttribute("aria-pressed", String(x === b)); });
        qty.value = b.dataset.pack;
        if (sum && btn) sum.textContent = money(+btn.dataset.unit * +b.dataset.pack);
      });
    });
  }
  function money(cents) {
    var fmt = A.money || "${{amount_no_decimals}}";
    var v = cents / 100;
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === "amount_no_decimals") return Math.round(v).toLocaleString("es-CO");
      if (k === "amount_no_decimals_with_comma_separator") return Math.round(v).toLocaleString("es-CO");
      if (k === "amount_with_comma_separator") return v.toLocaleString("es-CO", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return v.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    });
  }

  /* =========================================================
     TEST: subir el Nevado del Tolima (relieve real, SRTM)
     Preguntas, perfiles y salidas salen de los bloques de la sección.
     ========================================================= */
  function readQuiz(src) {
    var c = src.content, L = {}, TAGS = {};
    $$("[data-t]", c).forEach(function (b) { L[b.dataset.t] = b.textContent.trim(); });
    $$("[data-tag]", c).forEach(function (b) { TAGS[b.dataset.tag] = b.textContent.trim(); });
    var trips = {};
    $$("[data-trip]", c).forEach(function (t) { var d = t.dataset; trips[d.trip] = { id: d.trip, tags: (d.tags || "").split(" ").filter(Boolean), name: d.name, url: d.url, img: d.img, where: d.where, km: d.km, gain: d.gain, dif: d.dif, kind: d.kind, ts: +d.ts || 0 }; });
    return {
      L: L, TAGS: TAGS, trips: trips,
      qs: $$("[data-q]", c).map(function (q) {
        return { q: q.dataset.q, o: $$("button", q).map(function (b) { return { t: b.textContent.trim(), pts: +b.dataset.pts || 0, tags: (b.dataset.tags || "").split(" ").filter(Boolean), img: b.dataset.img || "" }; }) };
      }).filter(function (q) { return q.o.length; }),
      profiles: $$("[data-profile]", c).map(function (p) { return { name: p.dataset.profile, min: +p.dataset.min, max: +p.dataset.max, trips: p.dataset.trips.split(" ").filter(Boolean), desc: p.textContent.trim() }; })
    };
  }
  function tripCard(Q, x, why) {
    var t = Q.trips[x.id]; if (!t || (t.ts && t.ts < nowS)) return "";
    var chips = why.map(function (w) { return "<i>" + esc(Q.TAGS[w] || w) + "</i>"; }).join("");
    var kind = t.kind === "expe" ? Q.L.expe : Q.L.day + (t.ts && t.ts > nowS ? " · " + fmtDate(t.ts, "chip").toUpperCase() : "");
    var stats = (t.km ? "<span>" + t.km + " KM</span>" : "") + (t.gain ? "<span>+" + num(t.gain) + " M</span>" : "") + (t.dif ? "<span>DIF. " + t.dif + "/5</span>" : "");
    return '<a class="sug" href="' + esc(t.url) + '"><span class="sug-img"><img src="' + esc(t.img) + '" alt="" loading="lazy"></span>' +
      '<span class="sug-body"><span class="data sug-kind">' + esc(kind.toUpperCase()) + '</span><b class="sug-name">' + esc(t.name) + '</b><span class="data sug-where">' + esc((t.where || "").toUpperCase()) + '</span><span class="data sug-stats">' + stats + "</span>" +
      (chips ? '<span class="sug-why">' + chips + "</span>" : "") + '<span class="sug-go">' + esc(t.kind === "expe" ? Q.L.seeExpe : Q.L.see) + ' <svg width="16" height="16" aria-hidden="true"><use href="#i-arrow"/></svg></span></span></a>';
  }
  function mountClimb(el) {
    var src = el.parentNode.querySelector("template[data-quiz]");
    if (!src || !T || !T.tolima) return;
    var Q = readQuiz(src), L = Q.L; if (!Q.qs.length) return;
    var SUMMIT_M = +el.dataset.summit || 5215;
    var M = T.tolima, W = M.w, H = M.h, camps = M.camps, N = camps.length, n = Q.qs.length, uid = el.id;
    var ridges = M.lines.map(function (d, i) { return '<path class="rf" d="' + d + "L" + W + " " + H + "L0 " + H + 'Z"/><path class="rs" pathLength="1" style="--i:' + i + '" d="' + d + '"/>'; }).join("");
    el.innerHTML = '<div class="climb-mtn"><svg viewBox="0 0 ' + W + " " + H + '" aria-hidden="true"><defs><linearGradient id="' + uid + '-fade" x1="0" x2="1"><stop offset="0" stop-color="#fff" stop-opacity="0"/><stop offset=".12" stop-color="#fff"/><stop offset=".88" stop-color="#fff"/><stop offset="1" stop-color="#fff" stop-opacity="0"/></linearGradient><mask id="' + uid + '-m"><rect width="' + W + '" height="' + H + '" fill="url(#' + uid + '-fade)"/></mask></defs>' +
      '<g class="ridges" mask="url(#' + uid + '-m)">' + ridges + "</g>" +
      '<path class="m-path" d="' + M.route + '"/><path class="m-done" pathLength="1" d="' + M.route + '"/>' +
      camps.map(function (c, i) { return '<g class="camp" data-camp="' + i + '"><circle cx="' + c[0] + '" cy="' + c[1] + '" r="6"/><text x="' + (c[0] + 13) + '" y="' + (c[1] + 4) + '">' + (i === 0 ? "BASE" : i === N - 1 ? esc(L.summit.toUpperCase()) : "C" + i) + " · " + num(i === N - 1 ? SUMMIT_M : c[2]) + " M</text></g>"; }).join("") +
      '</svg><div class="climb-star">' + starSvg("width:100%;height:100%") + '</div><p class="climb-cap data">' + esc(el.dataset.cap || "") + "</p></div>" +
      '<div class="climb-card" aria-live="polite"></div><div class="climb-sugs" hidden></div>';
    var star = $(".climb-star", el), svg = $("svg", el), route = $(".m-done", el), card = $(".climb-card", el), sugs = $(".climb-sugs", el);
    var RL = route.getTotalLength ? route.getTotalLength() : 0, fr = camps.map(function (c, i) {
      if (!RL) return i / (N - 1);
      var best = 0, bd = 1e9; for (var s = 0; s <= 200; s++) { var p = route.getPointAtLength(RL * s / 200), dd = Math.hypot(p.x - c[0], p.y - c[1]); if (dd < bd) { bd = dd; best = s / 200; } }
      return best;
    });
    var elev = camps.map(function (c, i) { return i === N - 1 ? SUMMIT_M : c[2]; });
    var ans = [], step = 0, cur = 0, anim = 0;
    function fAt(s) { return fr[0] + (fr[N - 1] - fr[0]) * s / n; }
    function mAt(f) { for (var i = 1; i < N; i++) if (f <= fr[i]) return Math.round(lerp(elev[i - 1], elev[i], (f - fr[i - 1]) / Math.max(1e-6, fr[i] - fr[i - 1]))); return SUMMIT_M; }
    function placeAt(f) {
      var r = svg.getBoundingClientRect(), p = RL ? route.getPointAtLength(RL * f) : { x: camps[0][0], y: camps[0][1] };
      star.style.transform = "translate(" + (p.x / W * r.width).toFixed(1) + "px," + (p.y / H * r.height).toFixed(1) + "px)";
      route.style.strokeDashoffset = String(1 - f);
    }
    function moveTo(to) {
      $$(".camp", el).forEach(function (g, k) { g.classList.toggle("on", fr[k] <= to + .001); });
      var from = cur, t0 = performance.now(), D = 1000;
      cancelAnimationFrame(anim);
      if (reduce) { cur = to; placeAt(cur); return; }
      (function tick(now) { var p = Math.min(1, (now - t0) / D), e = p < .5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2; cur = lerp(from, to, e); placeAt(cur); if (p < 1) anim = requestAnimationFrame(tick); })(t0);
    }
    function dots() {
      return '<ol class="q-steps">' + Q.qs.map(function (_, i) {
        var can = i <= ans.length && i !== step;
        return '<li><button type="button" data-go="' + i + '"' + (can ? "" : " disabled") + (i === step ? ' aria-current="step"' : "") + (ans[i] != null ? ' class="done"' : "") + ' aria-label="' + esc(L.question) + " " + (i + 1) + '"></button></li>';
      }).join("") + "</ol>";
    }
    function result() {
      var score = 0, tags = {};
      ans.forEach(function (a, i) { var o = Q.qs[i].o[a]; if (!o) return; score += o.pts; o.tags.forEach(function (t) { tags[t] = (tags[t] || 0) + 1; }); });
      var pr = Q.profiles.find(function (p) { return score >= p.min && score <= p.max; }) || Q.profiles[Q.profiles.length - 1] || { name: "", desc: "", trips: [] };
      var list = pr.trips.map(function (id, k) { var tt = (Q.trips[id] || {}).tags || [], why = tt.filter(function (t) { return tags[t]; }); return { id: id, why: why, s: why.reduce(function (s, t) { return s + tags[t]; }, 0) * 10 - k }; })
        .sort(function (a, b) { return b.s - a.s; }).slice(0, 3);
      return { pr: pr, list: list };
    }
    function draw(focus) {
      moveTo(fAt(step));
      if (step >= n) {
        var R = result();
        star.classList.remove("burst"); void star.offsetWidth; star.classList.add("burst");
        card.innerHTML = '<div class="climb-result">' + dots() + '<span class="t-label sundown">' + esc(L.summit) + " · " + num(SUMMIT_M) + " m · " + esc(L.profile) + '</span><h3>' + esc(R.pr.name) + '</h3><p>' + esc(R.pr.desc) + "</p>" +
          '<div class="q-nav"><button class="btn" type="button" data-back><span>' + esc(L.change) + '</span></button><button class="btn" type="button" data-restart><span>' + esc(L.restart) + "</span></button></div></div>";
        var cards = R.list.map(function (x) { return tripCard(Q, x, x.why); }).join("");
        sugs.innerHTML = '<p class="t-label sugs-h">' + esc(L.sugs) + "</p>" + (cards ? '<div class="sugs-grid">' + cards + "</div>" : '<p class="muted">' + esc(L.empty) + "</p>");
        sugs.hidden = false; void sugs.offsetWidth; sugs.classList.add("in");
        if (focus) { var h = $("h3", card); h.setAttribute("tabindex", "-1"); h.focus({ preventScroll: true }); }
        return;
      }
      sugs.hidden = true; sugs.classList.remove("in");
      var q = Q.qs[step], m = mAt(fAt(step)), pics = q.o.every(function (o) { return o.img; });
      card.innerHTML = '<div class="climb-result">' + dots() + '<span class="t-label">' + (step ? "≈ " + num(m) + " M" : esc(L.base) + " · " + num(elev[0]) + " M") + " · " + esc(L.question.toUpperCase()) + " " + (step + 1) + "/" + n + '</span><p class="climb-q">' + esc(q.q) + "</p>" +
        '<div class="signs' + (pics ? " pics" : "") + '">' + q.o.map(function (o, k) {
          return '<button class="sign' + (pics ? " pic" : "") + '" type="button" data-a="' + k + '" aria-pressed="' + (ans[step] === k) + '">' + (pics ? '<img src="' + esc(o.img) + '" alt="" loading="lazy">' : "") + "<span>" + esc(o.t) + '</span><svg width="18" height="18" aria-hidden="true"><use href="#i-arrow"/></svg></button>';
        }).join("") + "</div>" +
        (step ? '<div class="q-nav"><button class="q-prev" type="button" data-prev><svg width="16" height="16" aria-hidden="true" style="transform:scaleX(-1)"><use href="#i-arrow"/></svg>' + esc(L.prev) + "</button>" + (ans[step] != null ? '<button class="q-prev" type="button" data-next>' + esc(L.next) + '<svg width="16" height="16" aria-hidden="true"><use href="#i-arrow"/></svg></button>' : "") + "</div>" : "") + "</div>";
      if (focus) { var f = $(".sign[aria-pressed=true]", card) || $(".sign", card); if (f) f.focus({ preventScroll: true }); }
    }
    el.addEventListener("click", function (e) {
      var b = e.target.closest("[data-a]");
      if (b) { ans[step] = +b.dataset.a; var s = step + 1; while (s < n && ans[s] != null) s++; step = s; draw(true); return; }
      var g = e.target.closest("[data-go]"); if (g && !g.disabled) { step = +g.dataset.go; draw(true); return; }
      if (e.target.closest("[data-prev]")) { step = Math.max(0, step - 1); draw(true); return; }
      if (e.target.closest("[data-next]")) { step = Math.min(n, step + 1); draw(true); return; }
      if (e.target.closest("[data-back]")) { step = n - 1; draw(true); return; }
      if (e.target.closest("[data-restart]")) { ans = []; step = 0; draw(true); }
    });
    if ("ResizeObserver" in window) new ResizeObserver(function () { placeAt(cur); }).observe(svg); else window.addEventListener("resize", function () { placeAt(cur); });
    onView(el, function () { el.classList.add("in"); }, .25);
    requestAnimationFrame(function () { placeAt(fAt(0)); cur = fAt(0); draw(false); });
  }

  /* =========================================================
     CIELO, ROLLO, VLOGS, REDES
     ========================================================= */
  function sky(canvas) {
    var ctx = canvas.getContext("2d"), stars = [], w, h, dpr = Math.min(2, window.devicePixelRatio || 1), running = false, raf;
    function size() { w = canvas.clientWidth; h = canvas.clientHeight; canvas.width = w * dpr; canvas.height = h * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); stars = []; var n = Math.round(w * h / 5200); for (var i = 0; i < n; i++) stars.push({ x: Math.random() * w, y: Math.random() * h * .9, r: Math.random() * 1.2 + .2, p: Math.random() * 6.28, s: .4 + Math.random() * 1.2, o: .25 + Math.random() * .6 }); }
    function frame(t) { ctx.clearRect(0, 0, w, h); for (var i = 0; i < stars.length; i++) { var s = stars[i]; ctx.globalAlpha = reduce ? s.o : s.o * (.55 + .45 * Math.sin(t / 1000 * s.s + s.p)); ctx.fillStyle = "#F4F4F4"; ctx.beginPath(); ctx.arc(s.x, s.y, s.r, 0, 6.283); ctx.fill(); } if (running && !reduce) raf = requestAnimationFrame(frame); }
    size(); frame(0);
    window.addEventListener("resize", function () { size(); frame(performance.now()); });
    if ("IntersectionObserver" in window && !reduce) new IntersectionObserver(function (es) { running = es[0].isIntersecting; if (running) raf = requestAnimationFrame(frame); else cancelAnimationFrame(raf); }).observe(canvas);
  }
  /* =========================================================
     FILTROS (bitácora, tienda, galería) Y LIGHTBOX
     ========================================================= */
  function filterGroup(g, cb) { g.addEventListener("click", function (e) { var b = e.target.closest("button"); if (!b) return; $$("button", g).forEach(function (x) { x.setAttribute("aria-pressed", String(x === b)); }); cb(b.dataset.f); }); }
  function initFilters() {
    $$("[data-filter-group]").forEach(function (g) {
      var kind = g.dataset.filterGroup, scope = g.closest("section") || g.parentNode;
      filterGroup(g, function (f) {
        if (kind === "logbook") {
          var rows = $$("[data-logbook] > li", scope), shown = 0;
          rows.forEach(function (r) {
            var dif = +r.dataset.dif, past = r.dataset.past === "true";
            var ok = f === "past" ? past : !past && (f === "all" || (f === "easy" && dif > 0 && dif <= 3) || (f === "hard" && dif >= 4));
            if (f === "all" && past) ok = true;
            r.hidden = !ok; if (ok) shown++;
          });
          var em = $("[data-logbook-empty]", scope); if (em) em.hidden = shown > 0;
          window.dispatchEvent(new Event("akko:layout"));
        } else if (kind === "shop") {
          $$("[data-shop-grid] .prod", scope).forEach(function (p) { p.hidden = f !== "all" && p.dataset.type !== f; });
        } else if (kind === "catalogo") {
          var n = 0;
          $$("[data-catalogo] > li", scope).forEach(function (r) { var ok = f === "all" || r.dataset.cat === f; r.hidden = !ok; if (ok) n++; });
          var ce = $("[data-catalogo-empty]", scope); if (ce) ce.hidden = n > 0;
        } else if (kind === "gallery") {
          $$("[data-masonry] [data-cat]", scope).forEach(function (p) { p.hidden = f !== "all" && p.dataset.cat !== f; });
          var rot = $("[data-rotator]", scope); if (rot && rot._refill) rot._refill();
        }
      });
    });
    initRotators();
    var mas = $("[data-masonry]"), lb = $("#lightbox"); if (!mas || !lb) return;
    var list = [], i = 0, back = null;
    function show(k) { i = (k + list.length) % list.length; var img = $("#lbImg"); img.src = list[i].dataset.full; img.style.animation = "none"; void img.offsetWidth; img.style.animation = ""; $("#lbCount").textContent = pad(i + 1) + " / " + pad(list.length); }
    function close() { lb.hidden = true; document.documentElement.style.overflow = ""; if (back && !back.closest("[hidden]")) back.focus(); }
    mas.addEventListener("click", function (e) {
      var b = e.target.closest("[data-full]"); if (!b) return;
      list = $$("[data-full]", mas).filter(function (x) { return !x.hidden; }); back = b;
      show(list.indexOf(b)); lb.hidden = false; document.documentElement.style.overflow = "hidden"; $("#lbClose").focus();
    });
    $("#lbClose").addEventListener("click", close);
    $("#lbPrev").addEventListener("click", function () { show(i - 1); });
    $("#lbNext").addEventListener("click", function () { show(i + 1); });
    lb.addEventListener("click", function (e) { if (e.target === lb || e.target.tagName === "FIGURE") close(); });
    var tx = 0, ty = 0;
    lb.addEventListener("touchstart", function (e) { tx = e.touches[0].clientX; ty = e.touches[0].clientY; }, { passive: true });
    lb.addEventListener("touchend", function (e) { var dx = e.changedTouches[0].clientX - tx, dy = e.changedTouches[0].clientY - ty; if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) show(i + (dx < 0 ? 1 : -1)); }, { passive: true });
    document.addEventListener("keydown", function (e) {
      if (lb.hidden) return;
      if (e.key === "Escape") close(); if (e.key === "ArrowRight") show(i + 1); if (e.key === "ArrowLeft") show(i - 1);
    });
  }

  /* =========================================================
     VITRINA ROTATIVA: cinco marcos fijos; cada cierto tiempo
     uno cambia de foto (fundido) hasta recorrer todas.
     Se detiene fuera de pantalla, con la pestaña oculta, al
     pasar el mouse o con foco, y con el botón Pausar.
     ========================================================= */
  function initRotators() {
    $$("[data-rotator]").forEach(function (rot) {
      var scope = rot.parentNode, mas = $("[data-masonry]", scope); if (!mas) return;
      var tiles = $$("[data-tile]", rot), ms = Math.max(3, +rot.dataset.interval || 4) * 1000;
      var tog = $("[data-rot-toggle]", rot), all = $("[data-rot-all]", rot), nEl = $("[data-rot-n]", rot);
      var pool = [], next = 0, last = -1, timer = 0, paused = reduce, visible = false, hover = false;
      function items() { return $$("[data-full]", mas).filter(function (b) { return !b.hidden; }); }
      function shuffle(a) { for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)), x = a[i]; a[i] = a[j]; a[j] = x; } return a; }
      function put(tile, b, fade) {
        var img = new Image(); img.alt = ""; img.decoding = "async"; img.src = b.dataset.src || b.dataset.full;
        tile._b = b;
        function go() {
          var old = $$("img", tile);
          if (fade) { img.className = "rot-in"; tile.appendChild(img); requestAnimationFrame(function () { requestAnimationFrame(function () { img.className = ""; }); }); setTimeout(function () { old.forEach(function (o) { o.remove(); }); }, 1300); }
          else { old.forEach(function (o) { o.remove(); }); tile.appendChild(img); }
        }
        if (img.decode) img.decode().then(go, go); else img.onload = go;
      }
      function refill() {
        pool = shuffle(items()); next = 0;
        if (nEl) nEl.textContent = "(" + pool.length + ")";
        rot.classList.toggle("is-few", pool.length < tiles.length);
        tiles.forEach(function (t, i) { t.hidden = !pool[i]; if (pool[i]) put(t, pool[i], false); });
        next = Math.min(tiles.length, pool.length);
      }
      function step() {
        if (pool.length <= tiles.length) return;
        var shown = tiles.map(function (t) { return t._b; }), k, guard = 0;
        do { k = Math.floor(Math.random() * tiles.length); } while ((k === last) && guard++ < 5);
        last = k;
        var b; guard = 0;
        do { b = pool[next % pool.length]; next++; } while (shown.indexOf(b) > -1 && guard++ < pool.length);
        put(tiles[k], b, !reduce);
      }
      function sync() {
        clearInterval(timer);
        if (!paused && visible && !hover && !document.hidden) timer = setInterval(step, ms);
      }
      function setPaused(p) {
        paused = p; tog.setAttribute("aria-pressed", String(p));
        $("use", tog).setAttribute("href", p ? "#i-play" : "#i-pause");
        $("span", tog).textContent = p ? tog.dataset.lPlay : tog.dataset.lPause; sync();
      }
      tog.addEventListener("click", function () { setPaused(!paused); });
      rot.addEventListener("mouseenter", function () { hover = true; sync(); });
      rot.addEventListener("mouseleave", function () { hover = false; sync(); });
      rot.addEventListener("click", function (e) { var t = e.target.closest("[data-tile]"); if (t && t._b) t._b.click(); });
      document.addEventListener("visibilitychange", sync);
      if ("IntersectionObserver" in window) new IntersectionObserver(function (es) { visible = es[0].isIntersecting; sync(); }, { threshold: .2 }).observe(rot);
      else visible = true;
      all.addEventListener("click", function () {
        if (rot.dataset.all === "lightbox") { var f = items()[0]; if (f) f.click(); return; }
        var open = mas.hidden; mas.hidden = !open; all.setAttribute("aria-expanded", String(open));
        all.firstChild.textContent = (open ? all.dataset.lLess : all.dataset.lAll) + " ";
        if (open) { setPaused(true); var b = items()[0]; if (b) b.focus({ preventScroll: true }); }
      });
      all.dataset.lAll = all.firstChild.textContent.trim(); all.dataset.lLess = rot.dataset.lLess || all.dataset.lAll;
      rot._refill = refill;
      refill(); setPaused(paused);
    });
  }

  /* =========================================================
     RESERVA DE SALIDA: datos de cada participante como
     propiedades del producto. Va al carrito y al checkout
     estándar de Shopify (Wompi incluido).
     ========================================================= */
  function initBookBar() {
    var bar = $("[data-book-bar]"), book = $("#reserva"); if (!bar || !book || !("IntersectionObserver" in window)) return;
    var seen = false, start = window.innerHeight * .6;
    function upd() { bar.hidden = seen || window.scrollY < start; }
    new IntersectionObserver(function (es) { seen = es[0].isIntersecting; upd(); }).observe(book);
    window.addEventListener("scroll", upd, { passive: true }); upd();
  }
  function initBooking() {
    initBookBar();
    var f = $("[data-book]"); if (!f) return;
    var sel = $("[data-people-count]", f), box = $("[data-people]", f), ok = $("#bkOk", f), d = box.dataset;
    var docTypes = (d.lDocTypes || "").split(",").map(function (s) { return s.trim(); }).filter(Boolean);
    var saved = {};
    function field(i, key, label, input) { return '<div class="field"><label for="p' + key + i + '">' + esc(label) + "</label>" + input + "</div>"; }
    function name(i, label) { return "properties[" + esc(d.lPerson) + " " + (i + 1) + " · " + esc(label) + "]"; }
    function person(i) {
      return '<fieldset style="padding:14px 0 0;margin:0;display:grid;gap:10px"><legend class="label" style="padding:0">' + esc(d.lPerson) + " " + (i + 1) + "</legend>" +
        field(i, "n", d.lName, '<input id="pn' + i + '" name="' + name(i, d.lName) + '" required autocomplete="' + (i ? "off" : "name") + '">') +
        '<div class="row2">' + field(i, "t", d.lDocType, '<select id="pt' + i + '" name="' + name(i, d.lDocType) + '">' + docTypes.map(function (t) { return "<option>" + esc(t) + "</option>"; }).join("") + "</select>") +
        field(i, "d", d.lDoc, '<input id="pd' + i + '" name="' + name(i, d.lDoc) + '" required inputmode="numeric">') + "</div>" +
        '<div class="row2">' + field(i, "b", d.lBirth, '<input id="pb' + i + '" name="' + name(i, d.lBirth) + '" type="date" required>') +
        field(i, "c", d.lPhone, '<input id="pc' + i + '" name="' + name(i, d.lPhone) + '" type="tel" required inputmode="tel" autocomplete="' + (i ? "off" : "tel") + '">') + "</div>" +
        (d.askEps === "true" ? field(i, "e", d.lEps, '<input id="pe' + i + '" name="' + name(i, d.lEps) + '" required>') : "") + "</fieldset>";
    }
    function people() {
      $$("input, select", box).forEach(function (x) { saved[x.id] = x.value; });
      var n = +sel.value, h = ""; for (var i = 0; i < n; i++) h += person(i);
      box.innerHTML = h;
      $$("input, select", box).forEach(function (x) { if (saved[x.id]) x.value = saved[x.id]; });
    }
    sel.addEventListener("change", people); people();
    var vs = $("[data-variant]", f), price = $("[data-price]");
    if (vs && price) vs.addEventListener("change", function () { price.textContent = vs.selectedOptions[0].dataset.price; });
    f.addEventListener("submit", function (e) {
      var bad = $$("input[required]", f).filter(function (i) { return !i.value.trim() || !i.checkValidity(); });
      $$("input[required]", f).forEach(function (i) { i.style.borderColor = (!i.value.trim() || !i.checkValidity()) ? "var(--orange)" : ""; });
      if (bad.length) { e.preventDefault(); bad[0].focus(); ok.textContent = ok.dataset.msg; }
    });
  }

  function syncPacks(f) {
    var qin = $("input[name=quantity]", f), su = $("[data-sum]", f); if (!qin) return;
    var n = Math.max(1, +qin.value || 1);
    $$("[data-pack-p]", f).forEach(function (x) { x.setAttribute("aria-pressed", String(+x.dataset.packP === n)); });
    if (su) su.textContent = n > 1 && su.dataset.unit ? "· " + money(+su.dataset.unit * n) : "";
  }
  /* Montaña interactiva: la estrella sube del campamento base a la cumbre */
  function initCumbre() {
    $$("[data-cumbre]").forEach(function (el) {
      var P; try { P = JSON.parse(el.dataset.points); } catch (e) { return; }
      P = P.filter(function (p) { return p[0] >= 0 && p[0] <= 1; }).sort(function (a, b) { return a[0] - b[0]; });
      if (P.length < 2) return;
      var last = P[P.length - 1];
      var ctrl = P.map(function (p) { return [p[0], +p[1]]; });
      var sumI = 0; P.forEach(function (p, i) { if (+p[1] > +P[sumI][1]) sumI = i; });
      if (last[0] < .99) ctrl.push([1, sumI === P.length - 1 ? +last[1] - (last[1] - P[0][1]) * .28 : +last[1]]);
      var minA = Math.min.apply(null, ctrl.map(function (p) { return p[1]; })), maxA = Math.max.apply(null, ctrl.map(function (p) { return p[1]; }));
      var H = 200, top = 22, bot = 14;
      function altAt(x) {
        for (var i = 0; i < ctrl.length - 1; i++) {
          var a = ctrl[i], b = ctrl[i + 1];
          if (x <= b[0]) { var t = (x - a[0]) / ((b[0] - a[0]) || 1); return a[1] + (b[1] - a[1]) * (1 - Math.cos(Math.PI * t)) / 2; }
        }
        return ctrl[ctrl.length - 1][1];
      }
      function yOf(alt) { return H - bot - (alt - minA) / ((maxA - minA) || 1) * (H - top - bot); }
      var seed = 11; function rnd() { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; }
      var N = 120, d = "";
      for (var i = 0; i <= N; i++) {
        var x = i / N, dist = Math.min.apply(null, ctrl.map(function (p) { return Math.abs(p[0] - x); }));
        var y = yOf(altAt(x)) + (rnd() - .5) * 3.4 * Math.min(1, dist / .05);
        d += (i ? " L" : "M") + (x * 1000).toFixed(1) + " " + y.toFixed(1);
      }
      $$("[data-c-line]", el).forEach(function (p) { p.setAttribute("d", d); });
      $$("[data-c-fill]", el).forEach(function (p) { p.setAttribute("d", d + " L1000 " + H + " L0 " + H + " Z"); });
      var stage = $("[data-cumbre-stage]", el), star = $("[data-cumbre-star]", el), clip = $("[data-cumbre-clip]", el);
      var camps = $("[data-cumbre-camps]", el), whereEl = $("[data-cumbre-where]", el), altEl = $("[data-cumbre-alt]", el), done = $("[data-cumbre-done]", el);
      var fmt = function (n) { return Math.round(n).toLocaleString("es-CO"); };
      var esc = function (t) { return String(t == null ? "" : t).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); };
      camps.innerHTML = P.map(function (p, i) {
        return '<span class="camp' + (i === sumI ? " summit" : "") + '" style="left:' + (p[0] * 100) + '%;--y:' + (yOf(p[1]) / H * 100).toFixed(2) + '%" data-i="' + i + '"><i></i><b><span class="camp-l">' + esc(p[2]) + '</span><span class="camp-s">' + esc(p[3] || p[2]) + "</span><span class=\"camp-m\"> · " + fmt(p[1]) + " m</span></b></span>";
      }).join("");
      var marks = $$(".camp", camps);
      star.setAttribute("aria-valuemax", String(maxA));
      var cur = 0, target = 0, raf = null, dragging = false, touched = false, sumX = P[sumI][0];
      function place(x) {
        var alt = altAt(x), slope = altAt(Math.min(1, x + .01)) - altAt(Math.max(0, x - .01));
        star.style.transform = "translate(" + (x * stage.clientWidth).toFixed(1) + "px," + (yOf(alt) / H * stage.clientHeight).toFixed(1) + "px) rotate(" + (-slope / ((maxA - minA) || 1) * 60).toFixed(1) + "deg)";
        clip.setAttribute("width", (x * 1000 + 10).toFixed(1));
        var at = -1, prev = 0;
        P.forEach(function (p, i) { if (Math.abs(p[0] - x) < .02) at = i; if (p[0] <= x + .02) prev = i; });
        marks.forEach(function (m, i) { m.classList.toggle("on", i <= prev); m.classList.toggle("here", i === at); });
        var where = at >= 0 ? P[at][2] : (prev >= P.length - 1 ? P[prev][2] : P[prev][2] + " → " + P[prev + 1][2]);
        if (whereEl.textContent !== where) whereEl.textContent = where;
        altEl.textContent = fmt(at >= 0 ? P[at][1] : alt);
        var top = at === sumI;
        el.classList.toggle("at-summit", x >= sumX - .02);
        star.classList.toggle("summit", top);
        star.setAttribute("aria-valuenow", String(Math.round(alt))); star.setAttribute("aria-valuetext", where + ", " + altEl.textContent + " m");
      }
      function tick() { cur += (target - cur) * (reduce ? 1 : .14); place(cur); if (Math.abs(cur - target) > .0005) raf = requestAnimationFrame(tick); else { cur = target; place(cur); raf = null; } }
      function go(x) { target = Math.max(0, Math.min(1, x)); if (!raf) raf = requestAnimationFrame(tick); }
      function fromEvent(e) { var r = stage.getBoundingClientRect(); return (e.clientX - r.left) / r.width; }
      var fine = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
      stage.addEventListener("pointermove", function (e) { if (dragging || (fine && e.pointerType === "mouse")) { touched = true; go(fromEvent(e)); } });
      star.addEventListener("pointerdown", function (e) { dragging = touched = true; try { star.setPointerCapture(e.pointerId); } catch (_) {} e.preventDefault(); });
      stage.addEventListener("pointerdown", function (e) { if (e.target.closest("[data-cumbre-star]")) return; touched = true; go(fromEvent(e)); });
      star.addEventListener("pointermove", function (e) { if (dragging) go(fromEvent(e)); });
      window.addEventListener("pointerup", function () { dragging = false; });
      window.addEventListener("pointercancel", function () { dragging = false; });
      star.addEventListener("keydown", function (e) {
        var i, step = e.shiftKey ? .1 : .02; touched = true;
        if (e.key === "ArrowRight" || e.key === "ArrowUp") { e.preventDefault(); go(target + step); }
        if (e.key === "ArrowLeft" || e.key === "ArrowDown") { e.preventDefault(); go(target - step); }
        if (e.key === "PageUp") { e.preventDefault(); for (i = 0; i < P.length; i++) if (P[i][0] > target + .01) { go(P[i][0]); break; } }
        if (e.key === "Home") { e.preventDefault(); go(0); } if (e.key === "End") { e.preventDefault(); go(sumX); }
      });
      window.addEventListener("resize", function () { place(cur); });
      place(0);
      // Pista: al verla por primera vez, la estrella sube sola al primer campamento.
      var hinted = false;
      if ("IntersectionObserver" in window) new IntersectionObserver(function (es) {
        if (es[0].isIntersecting && !hinted) { hinted = true; setTimeout(function () { if (!touched && P[1]) go(P[1][0]); }, reduce ? 0 : 500); }
      }, { threshold: .5 }).observe(stage);
    });
  }

  /* Ficha de producto: variantes con botones y cantidad */
  function initProduct() {
    $$("[data-product-form]").forEach(function (f) {
      var data = $("[data-variants]", f), idIn = $("[data-variant-id]", f), btn = $("[data-add-btn]", f), price = $("[data-price]");
      var variants = data ? JSON.parse(data.textContent) : null;
      $$("[data-option]", f).forEach(function (g) {
        g.addEventListener("click", function (e) {
          var b = e.target.closest("button"); if (!b) return;
          $$("button", g).forEach(function (x) { x.setAttribute("aria-pressed", String(x === b)); });
          if (!variants) return;
          var chosen = $$("[data-option]", f).map(function (gg) { var p = $("[aria-pressed=true]", gg); return p ? p.dataset.value : null; });
          var v = variants.find(function (x) { return x.options.every(function (o, k) { return chosen[k] == null || o === chosen[k]; }); });
          if (!v) return;
          idIn.value = v.id; if (price) price.textContent = v.price;
          var su = $("[data-sum]", f); if (su && v.cents != null) { su.dataset.unit = v.cents; syncPacks(f); }
          btn.disabled = !v.available; $("span", btn).textContent = v.available ? (TT.add || "Agregar al carrito") : (TT.soldOut || "Agotado");
        });
      });
    });
    // Paquetes (×1, ×5…) y total en el botón
    $$("[data-product-form]").forEach(function (f) {
      var qin = $("input[name=quantity]", f); if (!qin) return;
      f.addEventListener("click", function (e) {
        var b = e.target.closest("[data-pack-p]"); if (b) qin.value = b.dataset.packP;
        if (b || e.target.closest("[data-d]")) syncPacks(f);
      });
      qin.addEventListener("input", function () { syncPacks(f); });
      syncPacks(f);
    });
    $$("[data-qty]").forEach(function (q) {
      var input = $("input", q);
      q.addEventListener("click", function (e) {
        var b = e.target.closest("[data-d]"); if (!b || !input) return;
        input.value = Math.max(+input.min || 0, (+input.value || 0) + +b.dataset.d);
        if (input.hasAttribute("data-autosubmit")) input.form.submit();
      });
      if (input && input.hasAttribute("data-autosubmit")) input.addEventListener("change", function () { input.form.submit(); });
    });
  }

  /* =========================================================
     CABECERA, MENÚ, RIEL DE HORAS Y SENDERO
     ========================================================= */
  function initChrome() {
    var header = $("#header"), nav = $("#mobileNav"), menuBtn = $("#menuBtn"), menuClose = $("#menuClose");
    function openMenu() { nav.hidden = false; nav.classList.add("open"); document.body.style.overflow = "hidden"; menuBtn.setAttribute("aria-expanded", "true"); menuClose.focus(); }
    function closeMenu() { if (nav.hidden) return; nav.hidden = true; nav.classList.remove("open"); document.body.style.overflow = ""; menuBtn.setAttribute("aria-expanded", "false"); menuBtn.focus(); }
    if (menuBtn && nav) {
      menuBtn.addEventListener("click", openMenu); menuClose.addEventListener("click", closeMenu);
      document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeMenu(); });
      nav.addEventListener("click", function (e) { var a = e.target.closest("a"); if (a && a.getAttribute("href").indexOf("#") > -1) closeMenu(); });
    }
    var lastY = 0;
    window.addEventListener("scroll", function () {
      var y = window.scrollY;
      if (header) {
        header.classList.toggle("scrolled", y > 10);
        if (y > 140 && y > lastY + 4) header.classList.add("hide");
        else if (y < lastY - 6 || y < 140) header.classList.remove("hide");
      }
      lastY = y;
    }, { passive: true });
  }

  /* Revelados al entrar en pantalla (.rv) y elementos que se dibujan al verse */
  function initReveal() {
    var els = $$(".rv, .hist-photo, [data-steps]");
    if (!("IntersectionObserver" in window) || reduce) { els.forEach(function (el) { el.classList.add("in"); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } });
    }, { threshold: .14, rootMargin: "0px 0px -6% 0px" });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Experiencias: la estrella baja por la línea de tiempo con el scroll */
  function initTimeline() {
    var tl = $("[data-timeline]"); if (!tl || !tl.children.length) return;
    var bar = document.createElement("span"), star = document.createElement("span");
    bar.className = "tl-progress"; bar.setAttribute("aria-hidden", "true");
    star.className = "tl-star"; star.setAttribute("aria-hidden", "true"); star.innerHTML = starSvg("width:100%;height:100%");
    tl.appendChild(bar); tl.appendChild(star);
    var tick = false;
    function upd() {
      tick = false;
      var r = tl.getBoundingClientRect(), h = tl.offsetHeight - 12, k = (window.innerHeight * .55 - r.top) / Math.max(1, h);
      var y = Math.max(0, Math.min(1, reduce ? 1 : k)) * h;
      bar.style.height = y.toFixed(0) + "px"; star.style.transform = "translateY(" + (y + 6).toFixed(0) + "px)";
    }
    function req() { if (!tick) { tick = true; requestAnimationFrame(upd); } }
    window.addEventListener("scroll", req, { passive: true }); window.addEventListener("resize", req); window.addEventListener("akko:layout", req); upd();
  }

  /* =========================================================
     ESTRELLA GUÍA: en computador, la estrella de Akko recorre un sendero
     al costado mientras se baja por la página. Cada punto es una sección.
     ========================================================= */
  function initStarGuide() {
    var g = $("#starGuide");
    if (!g) return;
    var rail = $(".sg-rail", g), fill = $(".sg-fill", g), marks = $(".sg-marks", g), star = $(".sg-star", g);
    var secs = [], tick = false, lastP = -1, spin = 0;
    function build() {
      marks.innerHTML = ""; secs = [];
      var max = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      $$("#main > .shopify-section").forEach(function (s) {
        var h = s.querySelector("h1, h2"); if (!h || s.offsetHeight < 240) return;
        var top = s.getBoundingClientRect().top + window.scrollY, p = Math.max(0, Math.min(1, (top - 80) / max));
        var b = document.createElement("button");
        b.type = "button"; b.tabIndex = -1; b.style.top = (p * 100).toFixed(2) + "%";
        b.innerHTML = "<span>" + esc(h.textContent.replace(/\s+/g, " ").trim()) + "</span>";
        b.addEventListener("click", function () { window.scrollTo({ top: Math.max(0, top - 80), behavior: reduce ? "auto" : "smooth" }); });
        marks.appendChild(b); secs.push({ p: p, el: b });
      });
    }
    function upd() {
      tick = false;
      var max = Math.max(1, document.documentElement.scrollHeight - window.innerHeight), y = window.scrollY, p = Math.max(0, Math.min(1, y / max));
      g.classList.toggle("on", y > window.innerHeight * .35);
      g.classList.toggle("end", p > .995);
      if (lastP >= 0 && !reduce) spin += (p - lastP) * 540;
      lastP = p;
      fill.style.transform = "scaleY(" + p.toFixed(4) + ")";
      star.style.transform = "translate(-50%, " + (p * rail.offsetHeight).toFixed(1) + "px) rotate(" + spin.toFixed(1) + "deg)";
      secs.forEach(function (s) { s.el.classList.toggle("past", s.p <= p + .002); });
    }
    function req() { if (!tick) { tick = true; requestAnimationFrame(upd); } }
    star.addEventListener("click", function () { window.scrollTo({ top: 0, behavior: reduce ? "auto" : "smooth" }); });
    window.addEventListener("scroll", req, { passive: true });
    window.addEventListener("resize", function () { build(); req(); });
    window.addEventListener("load", function () { build(); req(); });
    window.addEventListener("akko:layout", function () { build(); req(); });
    build(); upd();
  }

  /* Video de salida: el completo se abre en un diálogo y se detiene al cerrar */
  function initVideo() {
    $$(".video-sec").forEach(function (sec) {
      var d = $("[data-vdialog]", sec), btn = $("[data-vplay]", sec); if (!d || !btn) return;
      var bg = $(".vband-media video", sec);
      if (bg && reduce) { bg.removeAttribute("autoplay"); bg.pause(); }
      btn.addEventListener("click", function () {
        if (d.showModal) d.showModal(); else d.setAttribute("open", "");
        var v = $("video", d), f = $("iframe", d);
        if (f && f.dataset.src && !f.src) f.src = f.dataset.src;
        if (v) { v.play && v.play().catch(function () {}); }
        if (bg) bg.pause();
      });
      function stop() { var v = $("video", d), f = $("iframe", d); if (v) v.pause(); if (f) f.removeAttribute("src"); if (bg && !reduce) bg.play().catch(function () {}); }
      $("[data-vclose]", d).addEventListener("click", function () { d.close ? d.close() : d.removeAttribute("open"); });
      d.addEventListener("close", stop);
      d.addEventListener("click", function (e) { if (e.target === d) d.close(); });
    });
  }

  /* Arranque. Cada módulo se protege para que un fallo no detenga a los demás. */
  function safe(fn, arg) { try { fn(arg); } catch (err) { if (window.console) console.error("[akko]", err); } }
  safe(initChrome); safe(initTopos); safe(tickCountdowns); setInterval(function () { safe(tickCountdowns); }, 1000);
  safe(initMap); safe(initCafe);
  $$("[data-climb]").forEach(function (el) { safe(mountClimb, el); });
  $$("canvas.sky").forEach(function (c) { safe(sky, c); });
  safe(initFilters); safe(initBooking); safe(initProduct); safe(initTimeline); safe(initReveal); safe(initStarGuide); safe(initVideo); safe(initCumbre);
  document.addEventListener("shopify:section:load", function () { location.reload(); });
})();
